<style scoped>
.el {
    padding-bottom: env(safe-area-inset-bottom);
}
</style>

<template>
    <div class="min-h-16 w-full flex flex-col shrink-0 rounded-b-[inherit] el">
        <slot></slot>
    </div>
</template>
